import { h } from 'preact';
import ActionSheetButton from './action-sheet-button';
import AddToCartButton from './add-to-cart-button';

function DrawerMobileBottomPanel() {
  return (
    <div className="flex items-center laptop:hidden bg-bg-2 bg-opacity-30">
      <ActionSheetButton mode="modal" />
      <AddToCartButton className="flex-1" />
    </div>
  );
}

export default DrawerMobileBottomPanel;
